<script setup lang="ts">
import StepsView from '../../views/StepsView/StepsView.vue';
import BPage from 'src/shared/components/base/BPage/BPage.vue';
</script>

<template>
  <BPage class="column">
    <div class="col fit scroll q-mt-md">
      <StepsView />
    </div>
  </BPage>
</template>
